<template>
  <div class="login">
    <echarts-map-bg/>
  </div>
</template>

<script>
import EchartsMapBg from './components/EchartsMapBg.vue'

export default {
  name: 'index',
  components: {
    EchartsMapBg
  }
}
</script>

<style scoped>
  .login {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 990;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue